import {Component, Input, OnInit} from '@angular/core';
import {MomentDateUtils} from '../utils/moment-date-utils';

@Component({
  selector: 'cm-new-feature-flag',
  template: `
    <span matTooltip="{{description}}" *ngIf="shouldShowNewFeature" class="mr-3">
      <i class="fas fa-star-exclamation"></i>
    </span>
  `,
  styles: [`
    /*Cause of weird bug, css is in layout/main.component.scss*/
  `],
  host: {'class': 'cm-new-feature-flag'}
})
export class NewFeatureFlagComponent implements OnInit{

  @Input()
  expiryDate: string;

  @Input()
  description: string;

  shouldShowNewFeature = false;
  constructor() {
  }
  ngOnInit(): void {
    this.shouldShowNewFeature = MomentDateUtils.moment(MomentDateUtils.today()).isBefore(MomentDateUtils.moment(this.expiryDate))
  }

}
